<template>
  <t-vdxb-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
  >
    <form v-if="show_form" class="t-vdxb-application-invite-user-form__form" @submit.prevent="handleSubmitForm">
      <a-vdxb-text>お申し込み者個人の情報を記入してください</a-vdxb-text>
      <div class="t-vdxb-application-invite-user-form__fields">
        <!--
        <m-form-input label="名前">
          <a-vdxb-text-field
            v-model="formData.name"
            type="text"
            placeholder="入力してください"
            :error="getFieldError('name')"
          />
        </m-form-input>
        -->
        <label class="m-form-input__label t-vdxb-application-invite-user-form__pc"
          >氏名<span class="m-form-input__type2">必須</span></label
        >
        <label class="m-form-input__label m-form-input__label2 t-vdxb-application-invite-user-form__sp"
          >氏名（姓）<span class="m-form-input__type2">必須</span></label
        >
        <m-form-input>
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="lastname"
              v-model="formData.lastname"
              type="text"
              placeholder="山田"
              maxlength="20"
              required
              :error="getFieldError('lastname')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.lastname.isError"
              v-html="backendErrorDict.lastname.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <label class="m-form-input__label m-form-input__label2 t-vdxb-application-invite-user-form__sp"
            >氏名（名）<span class="m-form-input__type2">必須</span></label
          >
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="name"
              v-model="formData.name"
              type="text"
              placeholder="太郎"
              maxlength="20"
              required
              :error="getFieldError('name')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.name.isError"
              v-html="backendErrorDict.name.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>

        <label class="m-form-input__label t-vdxb-application-invite-user-form__pc"
          >氏名カナ<span class="m-form-input__type2">必須</span></label
        >
        <label class="m-form-input__label m-form-input__label2 t-vdxb-application-invite-user-form__sp"
          >氏名カナ（姓）<span class="m-form-input__type2">必須</span></label
        >
        <m-form-input>
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="lastname_kana"
              v-model="formData.lastname_kana"
              type="text"
              placeholder="ヤマダ"
              maxlength="20"
              required
              :error="getFieldError('lastname_kana')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.lastname_kana.isError"
              v-html="backendErrorDict.lastname_kana.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <label class="m-form-input__label m-form-input__label2 t-vdxb-application-invite-user-form__sp"
            >氏名カナ（名）<span class="m-form-input__type2">必須</span></label
          >
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="name_kana"
              v-model="formData.name_kana"
              type="text"
              placeholder="タロウ"
              maxlength="20"
              required
              :error="getFieldError('name_kana')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.name_kana.isError"
              v-html="backendErrorDict.name_kana.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="生年月日" type2="必須">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="adminBirthDate"
              v-model="formData.adminBirthDate"
              type="text"
              placeholder="19800101"
              maxlength="8"
              required
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.adminBirthDate.isError"
              v-html="backendErrorDict.adminBirthDate.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>（例）1980年1月1日生まれの場合、19800101</li>
          </template>
        </m-form-input>
        <m-form-input label="職業" type2="必須">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-select-field
              id="-job"
              v-model="formData.job"
              required
              :options="jobs"
              :tabopen="tabopen"
              :error="getFieldError('job')"
            />
            <!-- eslint-disable -->
            <a-text
              v-if="backendErrorDict.adminJob.isError"
              v-html="backendErrorDict.adminJob.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <!--
        <m-form-input label="法人名（任意）">
          <a-vdxb-text-field
            v-model="formData.company_name"
            type="text"
            placeholder="入力してください"
            :error="getFieldError('company_name')"
          />
        </m-form-input>
        -->
        <m-form-input label="電話番号" type2="必須">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="phone_number"
              v-model="formData.phone_number"
              type="tel"
              placeholder="09012345678"
              maxlength="11"
              required
              :error="getFieldError('phone_number')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.adminPhoneNumber.isError"
              v-html="backendErrorDict.adminPhoneNumber.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>ハイフンは入れずにご入力ください。</li>
          </template>
        </m-form-input>
        <m-form-input label="メールアドレス" type2="必須">
          <!--
          <a-vdxb-text-field
            v-model="formData.email"
            type="email"
            placeholder="入力してください"
            required
            :error="getFieldError('email')"
          />
          -->
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="email"
              v-model="formData.email"
              type="text"
              placeholder="xxxx@kaisha.co.jp"
              maxlength="50"
              required
              :error="getFieldError('email')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.adminEmail.isError"
              v-html="backendErrorDict.adminEmail.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>キャリアメールは使えません</li>
          </template>
        </m-form-input>
        <p class="m-form-input__label">現在お住まいのご住所をご入力ください。</p>
        <m-form-input label="郵便番号" type2="必須">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="postal_code"
              v-model="formData.postal_code"
              type="text"
              placeholder="1234567"
              maxlength="7"
              required
              :error="getFieldError('postal_code')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.adminPostCode.isError"
              v-html="backendErrorDict.adminPostCode.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>ハイフンは入れずにご入力ください。</li>
          </template>
        </m-form-input>
        <!--
        <m-form-input label="住所">
          <a-vdxb-text-field
            v-model="formData.street_address"
            type="text"
            placeholder="全角"
            maxlength="80"
            required
            :error="getFieldError('street_address')"
          />
        </m-form-input>
        -->
        <m-form-input label="都道府県名" type2="必須">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-select-field
              id="-address1"
              v-model="formData.address1"
              required
              :options="prefectures"
              :tabopen="tabopen"
              :error="getFieldError('address1')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.adminAddress1.isError"
              v-html="backendErrorDict.adminAddress1.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="市区町村" type2="必須">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="address2"
              v-model="formData.address2"
              type="text"
              placeholder="千代田区"
              maxlength="20"
              required
              :error="getFieldError('address2')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.adminAddress2.isError"
              v-html="backendErrorDict.adminAddress2.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="字丁目番地など" type2="必須">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="address3"
              v-model="formData.address3"
              type="text"
              placeholder="大手町２－３－１"
              maxlength="20"
              required
              :error="getFieldError('address3')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.adminAddress3.isError"
              v-html="backendErrorDict.adminAddress3.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="住所建物など" type="任意">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="address4"
              v-model="formData.address4"
              type="text"
              placeholder="大手町プレイスウエストタワー"
              maxlength="20"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.adminAddress4.isError"
              v-html="backendErrorDict.adminAddress4.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>建物名・部屋番号などがある場合は必ずご記入ください。</li>
          </template>
        </m-form-input>
        <m-form-input label="販売チャネルコード" type="任意">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="salesChannelCode"
              v-model="formData.salesChannelCode"
              type="text"
              placeholder="12345678"
              maxlength="8"
              :error="getFieldError('salesChannelCode')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.salesChannelCode.isError"
              v-html="backendErrorDict.salesChannelCode.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>NTTコミュニケーションズの営業担当者より指示があった場合のみご記入ください。</li>
          </template>
        </m-form-input>
        <m-form-input label="販売担当者コード" type="任意">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="salesPersonCode"
              v-model="formData.salesPersonCode"
              type="text"
              placeholder="1234567"
              maxlength="9"
              :error="getFieldError('salesPersonCode')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.salesPersonCode.isError"
              v-html="backendErrorDict.salesPersonCode.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
          <template #note>
            <li>NTTコミュニケーションズの営業担当者より指示があった場合のみご記入ください。</li>
          </template>
        </m-form-input>
        <m-form-input label="販売担当者氏名（姓名）" type="任意">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="salesPerson"
              v-model="formData.salesPerson"
              type="text"
              placeholder="佐藤次郎"
              maxlength="20"
              :error="getFieldError('salesPerson')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.salesPerson.isError"
              v-html="backendErrorDict.salesPerson.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="販売担当者メールアドレス" type="任意">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="salesPersonEmailAddress"
              v-model="formData.salesPersonEmailAddress"
              type="text"
              placeholder="xxxx@kaisha.co.jp"
              maxlength="50"
              :error="getFieldError('salesPersonEmailAddress')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.salesPersonEmailAddress.isError"
              v-html="backendErrorDict.salesPersonEmailAddress.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <!--
        <m-form-input label="メールアドレス">
          <a-vdxb-text-field
            v-model="formData.email"
            type="email"
            placeholder="taro_yamada@4digit.jp"
            :error="getFieldError('email')"
          />
        </m-form-input>
        <m-form-input label="パスワード">
          <a-vdxb-text-field
            v-model="formData.password"
            type="password"
            placeholder="入力してください"
            :show-toggle="false"
            :error="getFieldError('password')"
          />
          <template #note>
            <li>半角英数字、6文字以上20文字以内</li>
          </template>
        </m-form-input>
        <m-form-input label="パスワード確認">
          <a-vdxb-text-field
            v-model="formData.password_confirm"
            type="password"
            placeholder="入力してください"
            :show-toggle="false"
            :error="getFieldError('password_confirm')"
          />
          <template #note>
            <li>半角英数字、6文字以上20文字以内</li>
          </template>
        </m-form-input>
        -->
        <a-vdxb-heading tag="h4" class="t-vdxb-application-invite-user-form__heading">
          ご利用の目的・ご想定の利用量について
        </a-vdxb-heading>
        <m-form-input label="利用目的" type2="必須">
          <div class="a-vdxb-text-field a-vdxb-text-field--text" required>
            <div class="t-vdxb-application-invite-user-form__includeerror">
              <textarea
                id="purpose"
                v-model="formData.purpose"
                class="a-vdxb-text-field__input"
                placeholder="顧客、取引先とのやりとりを行うため。"
                maxlength="100"
                required
                :error="getFieldError('purpose')"
              />
              <!-- eslint-disable -->
              <a-vdxb-text
                v-if="backendErrorDict.purposeOfUse.isError"
                v-html="backendErrorDict.purposeOfUse.msg"
                class="t-vdxb-application-invite-user-form__errormsg"
              />
              <!-- eslint-enable -->
            </div>
          </div>
          <template #note>
            <li>
              本サービスを第三者へ提供される場合は、以下もご記入ください。<br />　・電気通信番号使用計画の認定（みなし認定を含みます）を受けているか
            </li>
          </template>
        </m-form-input>
        <m-form-input label="利用予定の電話番号数（ご利用開始から1ヶ月間）" type="任意">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="expectedNumberOfPhoneNumber"
              v-model="formData.expectedNumberOfPhoneNumber"
              type="text"
              placeholder="5"
              maxlength="6"
              :error="getFieldError('expectedNumberOfPhoneNumber')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.expectedNumberOfPhoneNumber.isError"
              v-html="backendErrorDict.expectedNumberOfPhoneNumber.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="利用予定の電話番号数の最大値" type="任意">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="expectedMaxNumberOfPhoneNumber"
              v-model="formData.expectedMaxNumberOfPhoneNumber"
              type="text"
              placeholder="20"
              maxlength="6"
              :error="getFieldError('expectedMaxNumberOfPhoneNumber')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.expectedMaxNumberOfPhoneNumber.isError"
              v-html="backendErrorDict.expectedMaxNumberOfPhoneNumber.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="利用予定の電話発信回数（1ヶ月あたり）の最大値" type="任意">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="expectedMaxNumberOfOutgoingCalls"
              v-model="formData.expectedMaxNumberOfOutgoingCalls"
              type="text"
              placeholder="100"
              maxlength="6"
              :error="getFieldError('expectedMaxNumberOfOutgoingCalls')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.expectedMaxNumberOfOutgoingCalls.isError"
              v-html="backendErrorDict.expectedMaxNumberOfOutgoingCalls.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
        <m-form-input label="利用予定の電話着信回数（1ヶ月あたり）の最大値" type="任意">
          <div class="t-vdxb-application-invite-user-form__includeerror">
            <a-vdxb-text-field
              id="expectedMaxNumberOfIncomingCalls"
              v-model="formData.expectedMaxNumberOfIncomingCalls"
              type="text"
              placeholder="200"
              maxlength="6"
              :error="getFieldError('expectedMaxNumberOfIncomingCalls')"
            />
            <!-- eslint-disable -->
            <a-vdxb-text
              v-if="backendErrorDict.expectedMaxNumberOfIncomingCalls.isError"
              v-html="backendErrorDict.expectedMaxNumberOfIncomingCalls.msg"
              class="t-vdxb-application-invite-user-form__errormsg"
            />
            <!-- eslint-enable -->
          </div>
        </m-form-input>
      </div>
      <div class="t-vdxb-application-invite-user-form__buttons">
        <m-button-container>
          <!--
          <a-vdxb-button variant="block" submit="submit" color="primary" :disabled="hasError">次へ</a-button>
          -->
          <a-vdxb-button id="next" variant="block" submit="submit" color="primary" :disabled="hasErrorflg"
            >次へ</a-vdxb-button
          >
          <a-vdxb-button id="back" color="primary" @click="handleCancelClick">戻る</a-vdxb-button>
        </m-button-container>
      </div>
    </form>
    <teleport to="body">
      <o-vdxb-modal
        v-model:visible="resultModalVisible"
        class="o-vdxb-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-vdxb-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-vdxb-text>
        <template #footer>
          <a-vdxb-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-vdxb-modal>
    </teleport>
  </t-vdxb-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TVdxbDefaultEntrySidebar from '@/components/templates/vdxb-default-entry-sidebar';
import MFormInput from '@/components/molecules/form-input';
import AVdxbTextField from '@/components/atoms/vdxb-text-field';
import AVdxbButton from '@/components/atoms/vdxb-button';
import MButtonContainer from '@/components/molecules/button-container';
import { cloneDeep } from 'lodash';
import OVdxbModal from '@/components/organisms/vdxb-modal';
import { messageContent } from '@/common/messageContent.js';
import { customRequest } from '@/common/customRequest.js';
import { PREFECTURES } from '@/libs/constants';
import { JOBS } from '@/libs/constants';

import { customValidate } from '@/common/customValidate.js'; // #2456

import { utils } from '@/common/utils.js';

export default {
  name: 't-vdxb-application-invite-user-form',
  components: {
    TVdxbDefaultEntrySidebar,
    MFormInput,
    AVdxbTextField,
    AVdxbButton,
    MButtonContainer,
    OVdxbModal,
  },
  mixins: [messageContent, customRequest, customValidate], // #2456
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    /*
    errorList: {
      type: Object,
      default: null,
    },
*/
    handleFormSubmit: {
      type: Function,
      default: () => {},
    },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      hasErrorflg: true,
      // formData: {
      //   name: '',
      //   componay_name: '',
      //   phone_number: '',
      //   postal_code: '',
      //   street_address: '',
      //   email: '',
      //   password: '',
      //   password_confirm: '',
      // },
      formData: {
        lastname: this.$route.params.lastname,
        name: this.$route.params.name,
        lastname_kana: this.$route.params.lastname_kana,
        name_kana: this.$route.params.name_kana,
        adminBirthDate: this.$route.params.adminBirthDate,
        company_name: this.$route.params.company_name,
        phone_number: this.$route.params.phone_number,
        postal_code: this.$route.params.postal_code,
        street_address: this.$route.params.street_address,
        email: this.$route.params.email,
        purpose: this.$route.params.purpose,
      },
      sidebarInfo: {
        sidebarList: [
          { label: '契約情報の入力' },
          { label: '本人確認書類' },
          { label: '請求書送付先' },
          { label: 'お申し込み内容確認' },
        ],
        sidebarCurrent: 1,
        heading: '契約情報の入力',
        subHeading: 'Step 1',
        sidebarSubHeading: 'Sign Up',
        sidebarHeading: '新規お申し込み',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      prefectures: [],
      jobs: [],
      show_form: false,
      tmpUUID: '',
      tmpYMD: '',
      // #2456
      spCharCheckList: [
        {
          name: '氏名',
          fieldName: 'lastname',
        },
        {
          name: '氏名',
          fieldName: 'name',
        },
        {
          name: '氏名カナ',
          fieldName: 'lastname_kana',
        },
        {
          name: '氏名カナ',
          fieldName: 'name_kana',
        },
        {
          name: 'メールアドレス',
          fieldName: 'email',
        },
        {
          name: '職業',
          fieldName: 'job',
        },
        {
          name: '電話番号',
          fieldName: 'phone_number',
        },
        {
          name: '郵便番号',
          fieldName: 'postal_code',
        },
        {
          name: '市区町村',
          fieldName: 'address2',
        },
        {
          name: '字丁目番地など',
          fieldName: 'address3',
        },
        {
          name: '住所建物など',
          fieldName: 'address4',
        },
        {
          name: '利用目的',
          fieldName: 'purpose',
        },
        {
          name: '販売チャネルコード',
          fieldName: 'salesChannelCode',
        },
        {
          name: '販売担当者コード',
          fieldName: 'salesPersonCode',
        },
        {
          name: '販売担当者氏名（姓名）',
          fieldName: 'salesPerson',
        },
        {
          name: '販売担当者メールアドレス',
          fieldName: 'salesPersonEmailAddress',
        },
        {
          name: '利用予定の電話番号数（ご利用開始から1ヶ月間）',
          fieldName: 'expectedNumberOfPhoneNumber',
        },
        {
          name: '利用予定の電話番号数の最大値',
          fieldName: 'expectedMaxNumberOfPhoneNumber',
        },
        {
          name: '利用予定の電話発信回数（1ヶ月あたり）の最大値',
          fieldName: 'expectedMaxNumberOfOutgoingCalls',
        },
        {
          name: '利用予定の電話着信回数（1ヶ月あたり）の最大値',
          fieldName: 'expectedMaxNumberOfIncomingCalls',
        },
      ],
      backendErrorDict: {
        lastname: {
          isError: false,
          msg: '',
        },
        name: {
          isError: false,
          msg: '',
        },
        lastname_kana: {
          isError: false,
          msg: '',
        },
        name_kana: {
          isError: false,
          msg: '',
        },
        adminBirthDate: {
          isError: false,
          msg: '',
        },
        adminEmail: {
          isError: false,
          msg: '',
        },
        adminJob: {
          isError: false,
          msg: '',
        },
        adminPhoneNumber: {
          isError: false,
          msg: '',
        },
        adminPostCode: {
          isError: false,
          msg: '',
        },
        adminAddress1: {
          isError: false,
          msg: '',
        },
        adminAddress2: {
          isError: false,
          msg: '',
        },
        adminAddress3: {
          isError: false,
          msg: '',
        },
        adminAddress4: {
          isError: false,
          msg: '',
        },
        purposeOfUse: {
          isError: false,
          msg: '',
        },
        salesChannelCode: {
          isError: false,
          msg: '',
        },
        salesPersonCode: {
          isError: false,
          msg: '',
        },
        salesPerson: {
          isError: false,
          msg: '',
        },
        salesPersonEmailAddress: {
          isError: false,
          msg: '',
        },
        expectedNumberOfPhoneNumber: {
          isError: false,
          msg: '',
        },
        expectedMaxNumberOfPhoneNumber: {
          isError: false,
          msg: '',
        },
        expectedMaxNumberOfOutgoingCalls: {
          isError: false,
          msg: '',
        },
        expectedMaxNumberOfIncomingCalls: {
          isError: false,
          msg: '',
        },
      },
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      tabopen: 0,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-vdxb-application-invite-user-form');
      return `${baseClassName} ${this.class}`.trim();
    },
    hasError() {
      let isValid = true;
      if (this.errorList) {
        isValid = !Object.keys(this.errorList).length > 0;
      }
      return isValid;
    },
  },
  async created() {
    document.title = '契約情報の入力 | COTOHA Voice DX Basic';

    await this.getCookie('tmpUUID');
    await this.getCookie('tmpYMD');

    const tmpCompanyID = this.tmpUUID;
    if (typeof tmpCompanyID === 'undefined') {
      this.$router.push({ path: '/vdxbsignup' });
      return; // #2314
    }

    this.fetchTmpDataHandler();
  },
  mounted() {
    this.prefectures = PREFECTURES;
    this.jobs = JOBS;
    this.show_form = true;
    utils.setMetaDescription(this.$route);
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleSubmitForm(e) {
      e.preventDefault();

      const fe2beFieldNameMap = {
        email: 'adminEmail',
        job: 'adminJob',
        phone_number: 'adminPhoneNumber',
        postal_code: 'adminPostCode',
        address2: 'adminAddress2',
        address3: 'adminAddress3',
        address4: 'adminAddress4',
        purpose: 'purposeOfUse',
      };
      // #2456
      for (const item of this.spCharCheckList) {
        if (
          typeof this.formData[item.fieldName] !== 'undefined' &&
          this.hasSpecialCharacterInObject({ keyWord: this.formData[item.fieldName].replace(/\r?\n/g, '') })
        ) {
          const fieldName = fe2beFieldNameMap[item.fieldName] ? fe2beFieldNameMap[item.fieldName] : item.fieldName;
          const errMsg = messageContent.requireNotSpecialCharacter(item.name);
          this.setBackendErrorMsg([{ param: fieldName, msg: errMsg }]);
          this.showErrorModal(errMsg);
          return;
        }
      }

      let setAdminBirthDate = '';
      if (this.formData.adminBirthDate.length === 8) {
        const y = this.formData.adminBirthDate.substr(0, 4);
        const m = this.formData.adminBirthDate.substr(4, 2);
        const d = this.formData.adminBirthDate.substr(6);
        setAdminBirthDate = y + '-' + m + '-' + d;
      }

      const data = {
        lastname: this.formData.lastname,
        name: this.formData.name,
        lastname_kana: this.formData.lastname_kana,
        name_kana: this.formData.name_kana,
        adminBirthDate: setAdminBirthDate,
        adminEmail: this.formData.email,
        adminJob: this.formData.job,
        adminPhoneNumber: this.formData.phone_number,
        adminPostCode: this.formData.postal_code,
        adminAddress1: this.formData.address1,
        adminAddress2: this.formData.address2,
        adminAddress3: this.formData.address3,
        adminAddress4: this.formData.address4,
        purposeOfUse: this.formData.purpose,
        salesChannelCode: this.formData.salesChannelCode,
        salesPersonCode: this.formData.salesPersonCode,
        salesPerson: this.formData.salesPerson,
        salesPersonEmailAddress: this.formData.salesPersonEmailAddress,
        expectedNumberOfPhoneNumber: this.formData.expectedNumberOfPhoneNumber,
        expectedMaxNumberOfPhoneNumber: this.formData.expectedMaxNumberOfPhoneNumber,
        expectedMaxNumberOfOutgoingCalls: this.formData.expectedMaxNumberOfOutgoingCalls,
        expectedMaxNumberOfIncomingCalls: this.formData.expectedMaxNumberOfIncomingCalls,
        voicedxOnlyFlag: true,
      };

      //#2138
      if (typeof data.purposeOfUse !== 'undefined') {
        data.purposeOfUse = data.purposeOfUse.replace(/\n/g, '%%n%%');
      }

      const formDataTmp = {
        tmpCompanyID: this.tmpUUID,
        tmpYMD: this.tmpYMD,
        validate: true,
        data: data,
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      fetch('/signup/updateHistoryCollection', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = '/vdxbsignup';
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              if (Array.isArray(e.errors)) {
                this.setBackendErrorMsg(e.errors);
                const errMsg = e.errors.map(e => e.msg).join('<br />');
                this.showErrorModal(errMsg);
                return {};
              } else if (e.msg) {
                this.showErrorModal(e.msg);
              } else {
                throw new Error('/signup/updateHistoryCollection response was not ok.');
              }
            }

            this.$router.push({ path: '/vdxbsignup/upload' });
            return {};
          } else {
            window.location.href = '/vdxbsignup';
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('契約情報の入力'));
        });
    },
    // エラーリストを更新（引数無しで呼び出すとエラーを全て空にする）
    setBackendErrorMsg(errors) {
      Object.keys(this.backendErrorDict).forEach(fieldName => {
        this.backendErrorDict[fieldName].isError = false;
        this.backendErrorDict[fieldName].msg = '';
      });
      if (!Array.isArray(errors)) return;
      for (const error of errors) {
        if (typeof error.param !== 'string') continue;
        const fieldName = error.param.split('.').slice(-1)[0];
        const target = this.backendErrorDict[fieldName];
        target.isError = true;
        target.msg += target.msg === '' ? error.msg : `<br />${error.msg}`;
      }
    },
    getFieldError(key) {
      this.hasErrorflg = false;

      const arrInput = [
        'lastname',
        'name',
        'lastname_kana',
        'name_kana',
        'adminBirthDate',
        'email',
        'job',
        'phone_number',
        'postal_code',
        'address1',
        'address2',
        'address3',
        'purpose',
      ];

      for (let i = 0; i < arrInput.length; i++) {
        if (this.formData[arrInput[i]] === '') {
          this.hasErrorflg = true;
          return;
        }
      }
      /*
      if (this.errorList && this.errorList[key]) {
        return this.errorList[key];
      }
      return null;
*/
    },
    handleCancelClick() {
      this.$router.push('/vdxbsignup');
    },
    getCookie: async function (key) {
      await this.postRequest('/signup/getCookie', { key: key })
        .then(e => {
          this[key] = e.cookie_value;
          this.csrfToken = e.csrfToken;
          document.querySelector('meta[name="csrf-token"]').setAttribute('content', e.csrfToken);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('情報取得'));
        });
    },
    fetchTmpDataHandler: async function () {
      const formDataTmp = {
        tmpCompanyID: this.tmpUUID,
        tmpYMD: this.tmpYMD,
        collectionType: 'historyCollection',
        _csrf: this.csrfToken,
      };
      const formData = JSON.stringify(formDataTmp);
      return await fetch('/signup/getCollection', {
        method: 'POST',
        body: formData,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          if (response.status === 403) {
            window.location.href = '/vdxbsignup';
            return {};
          } else {
            return response.json();
          }
        })
        .then(e => {
          if (e.session) {
            if (e.status === 'failed') {
              throw new Error('/signup/getCollection response was not ok.');
            }
            this.setCurrentValue(e.data);
            return {};
          } else {
            window.location.href = '/vdxbsignup';
            return {};
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('契約情報の入力'));
        });
    },
    setCurrentValue(val) {
      if (!val.adminName) {
        this.formData.lastname = '';
        this.formData.name = '';
      } else {
        this.arrname = val.adminName.split('_');
        this.formData.lastname = this.arrname[0] || '';
        this.formData.name = this.arrname[1] || '';
      }

      if (!val.adminKanaName) {
        this.formData.lastname_kana = '';
        this.formData.name_kana = '';
      } else {
        this.arrnameKana = val.adminKanaName.split('_');
        this.formData.lastname_kana = this.arrnameKana[0] || '';
        this.formData.name_kana = this.arrnameKana[1] || '';
      }

      this.formData.adminBirthDate = val.adminBirthDate.replaceAll('-', '');
      this.formData.email = val.adminEmail;
      this.formData.job = val.adminJob;
      this.formData.phone_number = val.adminPhoneNumber;
      this.formData.postal_code = val.adminPostCode;
      this.formData.address1 = val.adminAddress1;
      this.formData.address2 = val.adminAddress2;
      this.formData.address3 = val.adminAddress3;
      this.formData.address4 = val.adminAddress4;
      this.formData.purpose = val.purposeOfUse;
      this.formData.salesChannelCode = val.salesChannelCode;
      this.formData.salesPersonCode = val.salesPersonCode;
      this.formData.salesPerson = val.salesPerson;
      this.formData.salesPersonEmailAddress = val.salesPersonEmailAddress;
      this.formData.expectedNumberOfPhoneNumber = val.expectedNumberOfPhoneNumber;
      this.formData.expectedMaxNumberOfPhoneNumber = val.expectedMaxNumberOfPhoneNumber;
      this.formData.expectedMaxNumberOfOutgoingCalls = val.expectedMaxNumberOfOutgoingCalls;
      this.formData.expectedMaxNumberOfIncomingCalls = val.expectedMaxNumberOfIncomingCalls;

      if (val['businessType'] === 'company') {
        this.sidebarInfo.sidebarList[0] = { label: '契約情報の入力' };
        this.sidebarInfo.sidebarList[1] = { label: '本人確認書類' };
        this.sidebarInfo.sidebarList[2] = { label: '契約情報の入力(法人)' };
        this.sidebarInfo.sidebarList[3] = { label: '法人の確認書類' };
        this.sidebarInfo.sidebarList[4] = { label: '請求書送付先' };
        this.sidebarInfo.sidebarList[5] = { label: 'お申し込み内容確認' };
        this.sidebarInfo.sidebarCurrent = 1;
        this.sidebarInfo.subHeading = 'Step 1';
      }
    },
  },
};
</script>
